<template>
  <div class="radio-container">
    <!-- 设置此题目必答时点击提交问卷需要判断此题是否已做答 -->
    <div :class="[isValided ? 'error-border' : 'common-container']">
      <div class="quesName">
        <span v-show="isQuestionNum">{{ index }}.</span>
        <!-- 修改：支持解析HTML标签的题目名称 -->
        <span
          class="question-name-text"
          v-html="formattedQuestionName"
          @click="handleHtmlClick"
        ></span>
        <!-- <span class="question-name-text">{{ radioOption.name }}</span> -->
        <span class="starRed" v-if="radioOption.isMust == 1">*</span>
        <span style="margin-left: 10px" v-if="score">({{ score }}) 分</span>
      </div>
      <el-form :model="radioOption" ref="radioForm" :rules="rules">
        <div
          class="option-container"
          v-for="(childitem, childindex) in radioOption.optionsData"
          :key="childindex"
        >
          <el-radio
            :disabled="isAnswered"
            v-model="radioValue"
            :label="childitem.id"
            @change="handleRadioChange(childitem, childindex, $event)"
          >
            <!-- 修改：支持解析HTML标签的选项内容 -->
            <div
              class="radio-text"
              v-html="formattedOptionName(childitem.name)"
              @click="handleHtmlClick"
            ></div>
            <!-- <div class="radio-text">{{ childitem.name }}</div> -->
          </el-radio>
          <el-form-item
            label-width="0"
            :prop="'optionsData.' + childindex + '.textValue'"
            :rules="rules.textValue"
          >
            <el-input
              :disabled="isAnswered"
              :key="childindex"
              v-model="childitem.textValue"
              v-if="childitem.isInput == 1"
              @input="handleInput(childitem)"
              @focus="handleRadioChange(childitem, childindex)"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 图片预览 -->
    <van-image-preview
      v-model="showPreview"
      :images="previewImageUrl"
      @close="handleClose"
    />
  </div>
</template>

<script>
import notice from "../notice/notice.js";
// 引入图片预览组件
export default {
  props: {
    //当前题目的所有相关信息
    previewOption: {
      type: Object,
    },
    //该题目在当前问卷中的序号
    index: {
      type: Number,
    },
    //该题目是否已做答，true为已答过，false为未答
    isAnswered: {
      type: Boolean,
    },
    //是否显示题目序号，true为显示，false为不显示
    isQuestionNum: {
      type: Boolean,
    },
  },
  created() {
    this.radioOption = this.previewOption;
    this.radioOption.optionsData.map((el) => {
      if (el.score !== undefined && el.score > 0) {
        this.score = el.score;
      }
    });
    this.previewOption.optionsData = this.previewOption.optionsData.map(
      (element) => {
        return {
          ...element,
          optionId: element.id, //选项id
          optionName: "", //选项label
          textValue: "", //保存选项后的输入框的值
        };
      }
    );
    if (this.previewOption.answers.length > 0) {
      this.radioValue = this.previewOption.answers[0].optionId;
      this.previewOption.optionsData.forEach((item) => {
        this.previewOption.answers.forEach((answerOption) => {
          if (item.optionId === answerOption.optionId) {
            item.textValue = answerOption.textValue;
          }
        });
      });
    }
  },
  data() {
    return {
      //单选题目的示例数据
      radioOption1: {
        name: "1.单选题卡啦啦啦啦啦啦啦",
        optionsData: [
          {
            name: "还是啥",
            isInput: 1,
          },
          {
            name: "看到啥",
            isInput: 1,
          },
          {
            name: "参加反馈啥",
            isInput: 1,
          },
          {
            name: "发出发啥",
            isInput: 1,
          },
        ],
        isMust: 1, //是否必填，必填时显示红色*
        rowCount: 0, //排序方式 5.横排 1.竖排 2.一排2个 3.一排3个 4.一排4个
      },
      score: "", //分数
      radioOption: {},
      answerVal: [], //保存当前题目的答卷信息，父页面（答题页面）获取后用于构造答卷的请求参数
      isAnswer: false, //标志当前题目是否已做答
      isValided: false, //标志当前题目是否校验通过
      radioValue: "",
      rules: {
        textValue: [
          { min: 1, max: 200, message: "长度小于200个字符", trigger: "blur" },
        ],
      },
      previewImageUrl: [],
      showPreview: false,
    };
  },
  computed: {
    formattedQuestionName() {
      let htmlContent = this.radioOption.name || "";
      // 如果包含img标签，则设置图片大小为100px
      if (htmlContent.includes("<img")) {
        // 使用正则表达式匹配所有img标签并添加样式
        htmlContent = htmlContent.replace(/<img(.*?)>/g, (match, p1) => {
          // 检查是否已存在style属性
          if (p1.includes("style=")) {
            // 如果已存在style属性，在原有样式基础上添加width和height
            return match.replace(
              /style="(.*?)"/,
              'style="$1; width: 80px; height: 60px;"'
            );
          } else {
            // 如果不存在style属性，添加新的style属性
            return `<img${p1} style="width: 85px; height: 60px; margin:0px 5px">`;
          }
        });
      }

      return htmlContent;
    },
  },

  methods: {
    handleClose() {
      this.showPreview = false;
    },
    // 添加：处理选项名称格式化
    formattedOptionName(optionName) {
      let htmlContent = optionName || "";
      // 如果包含img标签，则设置图片大小为100px
      if (htmlContent.includes("<img")) {
        // 使用正则表达式匹配所有img标签并添加样式
        htmlContent = htmlContent.replace(/<img(.*?)>/g, (match, p1) => {
          // 检查是否已存在style属性
          if (p1.includes("style=")) {
            // 如果已存在style属性，在原有样式基础上添加width和height
            return match.replace(
              /style="(.*?)"/,
              'style="$1; width: 80px; height: 60px;"'
            );
          } else {
            // 如果不存在style属性，添加新的style属性
            return `<img${p1} style="width: 85px; height: 60px; margin:0px 5px">`;
          }
        });
      }

      return htmlContent;
    },

    // 添加：处理HTML内容点击事件
    handleHtmlClick(event) {
      if (event.target.tagName === "IMG") {
        this.previewImageUrl = event.target.src.split(",");
        // this.imagePreviewVisible = true;
        this.showPreview = true;
      }
    },

    handleRadioChange(optionItem, optionIndex, val) {
      //清空其他选项输入框的值
      this.previewOption.optionsData.forEach((item, index) => {
        if (optionIndex !== index) {
          item.textValue = "";
          item.optionName = "";
        }
      });
      //val为undefined表示输入框获取到焦点，此时默认选中当前行的radio
      if (val === undefined) {
        this.radioValue = optionItem.id;
      }
      this.previewOption.optionsData[optionIndex].optionName = optionItem.name;
      //获取radio选中的值，当optionId和optionName同事存在当前的radio值才有效
      const answerArray = this.previewOption.optionsData.filter((item) => {
        return item.optionId && item.optionName;
      });
      this.answerVal = answerArray.map((item) => {
        return {
          pvqId: localStorage.getItem("currentQuestionId"), //问卷id
          questionId: this.radioOption.id, //题目id
          questionType: this.radioOption.type, //题目类型
          optionId: item.id, //选项id
          optionName: item.optionName, //选项label
          textValue: item.textValue, //保存选项后的输入框的值
        };
      });
      this.isAnswer = true;
      this.radioOption.isMust === 1 &&
        this.$parent.setAnswerPercentage(this.radioOption.id, this.isAnswer);
      this.doValided();
      //观察者触发
      notice.emitBrother("questionnaireObserver");
    },
    handleInput(optionItem) {
      this.isValided = false;
      this.answerVal[0].textValue = optionItem.textValue;
    },
    validedForm() {
      let validedResult = true;
      this.$refs["radioForm"].validate((result) => {
        if (result) {
          validedResult = false;
        } else {
          validedResult = true;
        }
      });
      return validedResult;
    },

    checkValided() {
      if (this.radioOption.isMust === 0) {
        return false;
      }
      //判断当前题目是否必填，必填时才需要判断是否已答
      if (this.radioOption.isMust !== 1) {
        return true;
      }
      //判断当前题目是否已答
      if (!this.isAnswer) {
        return true;
      }
      return this.validedForm();
      return false;
    },
    doValidedFlag() {
      return this.checkValided();
    },
    doValided() {
      this.isValided = this.checkValided();
      return this.isValided;
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus">
.radio-container {
  padding: 10px;

  .quesName {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .starRed {
    color: red;
    font-weight: 600;
  }

  .question-name-text {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #353535;
    display: flex;
    align-items: center;
  }

  .option-container {
    display: flex;
    padding: 10px 0;
    align-items: flex-start;
    flex-direction: column;

    .el-radio__input.is-checked .el-radio__inner {
      border-color: #2cc7c5;
      background: #2cc7c5;
    }

    .el-radio__input.is-checked+.el-radio__label {
      color: #2cc7c5;
    }

    .el-input__inner:focus {
      border: 1px solid #2CC7C5;
      outline: none;
    }

    // 单选按钮容器
    .el-radio {
      margin-right: 0;
      display: inherit;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
    }

    .quesScore {
      margin-left: 10px;
      color: #c0c4cc;
    }

    // 单选按钮的文字
    .el-radio__label {
      color: #000;
    }

    .radio-text {
      word-break: normal;
      width: auto;
      display: block;
      white-space: pre-wrap;
      word-wrap: break-word;
      overflow: hidden;
      line-height: 20px;
    }

    // 输入框
    .el-input__inner {
      width: calc(100% - 34px);
      margin-left: 24px;
    }

    // 单选按钮框
    .el-radio__inner {
      position: relative;
      top: calc(50% - 7px);
    }

    // 校验提示文字
    .el-form-item__error {
      left: 24px;
    }

    // .el-form-item.is-success .el-input__inner,
    // .el-form-item.is-success .el-input__inner:focus,
    // .el-form-item.is-success .el-textarea__inner,
    // .el-form-item.is-success .el-textarea__inner:focus{
    // border-color: #2cc7c5;
    // }
    .el-form-item {
      margin-bottom: 0px;
    }

    // 修改被全局样式覆盖的
    .el-radio__inner, .el-radio__input.is-checked .el-radio__inner {
      width: 14px;
      height: 14px;
    }

    .el-radio__inner::after {
      width: 7px;
      height: 7px;
    }
  }

  .common-container {
    border: 1px solid transparent;
    padding: 9px;
  }

  .error-border {
    border: 1px solid red;
    padding: 9px;
  }

  // radio在disable时的样式
  .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {
    border-color: #f5f7fa;
    background: #f5f7fa;
  }

  .el-radio__input.is-disabled+span.el-radio__label {
    color: #C0C4CC !important;
    cursor: not-allowed;
  }

  .el-form-item.is-success .el-input__inner {
    border-color: #DCDFE6;
  }

  .el-form-item.is-success .el-input__inner:focus {
    border-color: #2CC7C5;
  }

  .radio-container .option-container .el-radio {
    display: flex;
    align-items: center;
  }
}
</style>